import React, { useMemo } from 'react';
import SolarMap from '../../../../map-views/SolarMap';
import RenewablePotentialChartCard from './RenewablePotentialChartCard';
import RenewableMapLoadingOverlay from './states/RenewableMapLoadingOverlay';
import RenewableMapErrorOverlay from './states/RenewableMapErrorOverlay';
import SolarCapacityFactorLegendPanel from './SolarCapacityFactorLegendPanel';
import SolarPotentialStatisticsGrid from './SolarPotentialStatisticsGrid';

const SolarEnergyPotentialCard = ({
  countryIso,
  solarData,
  solarThresholds,
  solarStatistics,
  isSolarLoading,
  error,
  isTabActive = true,
}) => {

  const mapView = useMemo(() => (
    <SolarMap
      countryIso={countryIso}
      solarData={solarData}
      solarThresholds={solarThresholds}
      className="w-full h-full"
      layoutActive={isTabActive}
    />
  ), [countryIso, solarData, solarThresholds, isTabActive]);


  const overlayLegend = useMemo(() => (
    <SolarCapacityFactorLegendPanel
      solarThresholds={solarThresholds}
      placement="overlay"
    />
  ), [solarThresholds]);

  const inlineLegend = useMemo(() => (
    <SolarCapacityFactorLegendPanel
      solarThresholds={solarThresholds}
      placement="inline"
    />
  ), [solarThresholds]);

  const statisticsGrid = useMemo(() => (
    <SolarPotentialStatisticsGrid solarStatistics={solarStatistics} />
  ), [solarStatistics]);


  const overlayContent = useMemo(() => {
    if (isSolarLoading) {
      return (
        <RenewableMapLoadingOverlay
          message="Loading solar data..."
        />
      );
    }

    if (error) {
      return (
        <RenewableMapErrorOverlay title="Unable to Load Solar Data">
          <div className="text-xs text-red-600">{error}</div>
        </RenewableMapErrorOverlay>
      );
    }

    return null;
  }, [isSolarLoading, error]);


  return (
    <RenewablePotentialChartCard title="Solar Energy Potential">

      <div className="h-96 min-h-[16rem] sm:h-96 w-full min-w-0 relative bg-gray-100 overflow-hidden">

        {mapView}

        {overlayContent}

        {overlayLegend}

      </div>

      <div className="w-full min-w-0 mt-3 sm:mt-4 flex flex-wrap items-center gap-2 overflow-x-auto pb-0.5">

        {statisticsGrid}

        <div className="ml-auto mr-1 sm:mr-2 flex-shrink-0">

          {inlineLegend}

        </div>

      </div>

    </RenewablePotentialChartCard>
  );
};

export default SolarEnergyPotentialCard;